<script setup lang="ts">
export interface DynoPrvok {
  type: string
  value: string | string[]
  label: string
}

const props = withDefaults(defineProps<DynoPrvok>(), {
  type: undefined,
  value: undefined,
  label: undefined,
})

function showDefaultType() {
  switch (props?.type) {
    case 'text':
    case 'textarea':
    case 'url':
    case 'combobox':
    case 'radio':
    case 'date':
    case 'time':
    case 'number':
    case 'dateTime':
      return true
    default:
      return false
  }
}

function showMultiType() {
  switch (props?.type) {
    case 'checkbox':
    case 'multiselect':
      return true
    default:
      return false
  }
}

function showEmailTelType() {
  switch (props?.type) {
    case 'email':
    case 'tel':
      return true
    default:
      return false
  }
}
</script>

<template>
  <template v-if="showMultiType()">
    <IDSKParagraph class="mb-2">
      <b>
        {{ props.label }}
      </b>
    </IDSKParagraph>
    <IDSKParagraph class="mb-6">
      <span v-for="(item, key) in props.value" :key="key" class="d-block mb-2">
        {{ item }}
      </span>
    </IDSKParagraph>
  </template>

  <template v-else-if="showDefaultType()">
    <IDSKParagraph class="mb-2">
      <b>
        {{ props.label }}
      </b>
    </IDSKParagraph>
    <IDSKParagraph class="mb-6">
      {{ props.value }}
    </IDSKParagraph>
  </template>

  <template v-else-if="showEmailTelType()">
    <DisplayList class="mb-6">
      <dt>
        <b>{{ props.label }}</b>
      </dt>
      <dd>{{ props.value }}</dd>
    </DisplayList>
  </template>
</template>
